import React from 'react';
import { CheckIcon, PickaxeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Mineral Processing with confidence starting today'];
export function FinalCta() {
  return <section className="bg-navy-soft py-16 sm:py-20" aria-labelledby="final-title" data-id="element-86" data-mp="1jbk882we4r84">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-87" data-mp="1ed8wtnqg68ns">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-mineral" data-id="element-88" data-mp="1t2okuvylfzzs">
          <PickaxeIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="1o3brrth4pwor" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-90" data-mp="2233b89qf05a5">
          Created by mineral processing education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-91" data-mp="n6w7h09dnscq" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-gold bg-steel p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-92" data-mp="n7yx74uyror2">
          <p data-id="element-93" data-mp="x2h22dc49qcg">
            <b className="block text-sm uppercase leading-tight text-white" data-id="element-94" data-mp="x5v41kgvbxjd">{productShortName}</b>
            <span className="text-sm text-muted" data-id="element-95" data-mp="120sg709g2n0h">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-96" data-mp="1b28on2gp8f22">
            <p className="text-sm text-muted" data-id="element-97" data-mp="1fu9w8b2x9hlr">
              <span className="mr-2 line-through" data-id="element-98" data-mp="1fvl0sd46ytdx">{priceBefore}</span>
              <b className="text-base text-mineral" data-id="element-99" data-mp="1ktwa8mqkr1vm">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-100" data-mp="1psfy4soqanqm">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-101" data-mp="3quov8ozk0jm8">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="3lwvr01ht9zol">
              <CheckIcon className="h-4 w-4 text-mineral" aria-hidden="true" data-id="element-103" data-mp="3i4q8vx37guc" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}